import React from 'react';
import HeadingDescription from '../HeadingDescription';
import TechnicalDataTable from '../TechnicalDataTable';
import PointersWithHeading from '../PointersWithHeading';
import { getTableData } from './utils';
import boothImg from '../../assets/proposalImages/powder_coating_booth_automatic.jpg';
import ProposalImage from '../ProposalImage';


export default function RecoveryBoothPreTreatmentSection({ recoveryBoothContent, recoverySpec, ptSpec, ptStepsData, uploadedImage }) {
  const hasRecovery = recoveryBoothContent || recoverySpec;
  const hasPt = ptSpec || ptStepsData?.steps;

  if (!hasRecovery && !hasPt) return null;

  return (
    <>
      <div className="a4-paddings quotation-page quotation-page-compact">
        <div className="quotation-page-inner quotation-bg-light">
          {hasRecovery && (
            <div className="quotation-section-block">
              {/* <HeadingDescription heading="Recovery Booth – Pollution Free" description="" level={2} /> */}
              <HeadingDescription heading="Powder Coating Booth" description="" level={2} />
              <HeadingDescription
                heading="Powder Coating Mono-Cyclonic Recovery Spray Booth"
                description={recoveryBoothContent?.description}
                level={3}
              />
              {recoveryBoothContent?.items?.items && (
                <PointersWithHeading
                  items={recoveryBoothContent.items.items.map((it) => ({ title: it.title, description: it.description }))}
                  numbered
                />
              )}
              <ProposalImage src={uploadedImage || boothImg} wrapperStyle={{ marginBottom: 12, marginTop: 12 }} imgStyle={uploadedImage ? { maxHeight: 500, width: 'auto', objectFit: 'contain' } : {}} />

            </div>
          )}

        </div>
      </div>
      <div className="a4-paddings quotation-page quotation-page-compact">
        <div className="quotation-page-inner quotation-bg-light">
          {recoverySpec && (
            <TechnicalDataTable data={recoverySpec.data || getTableData(recoverySpec)} title={recoverySpec?.label || 'Technical Specifications'} />
          )}
        </div>
      </div>
    </>
  );
}
